import { atom } from '@podium/store';
import type { PrebidKeyValue } from '@schibsted-nmp/advertising-shared';
import { AtomChannels, AtomTopics } from '@client/core/atoms/consts.js';

export const $prebidTargetingAtom = atom<$prebidTargetingAtom.Value>(
  AtomChannels.Podlet,
  AtomTopics.PrebidTargeting,
  []
);

export namespace $prebidTargetingAtom {
  export type Value = Array<PrebidKeyValue>;
}

/**
 * Updates the global targeting state with new key-value pairs for Prebid.
 *
 * The function merges the current targeting state with the new targeting values, ensuring:
 * - Keys are unique in the final state.
 * - If a key already exists, its values are merged with the new values.
 * - Duplicate values for the same key are removed.
 *
 * @param prebidTargeting - An array of PrebidKeyValue objects to add to the global targeting state.
 */
export function setPrebidTargetingAtom(prebidTargeting: Array<PrebidKeyValue>) {
  const currentTargeting = $prebidTargetingAtom.value ?? [];
  const combinedTargeting = [...currentTargeting, ...prebidTargeting];

  const targetingMap: Record<string, string[]> = {};

  for (const { key, value } of combinedTargeting) {
    const existing = targetingMap[key] ?? [];
    targetingMap[key] = Array.from(new Set([...existing, ...value]));
  }

  const mergedTargeting = Object.entries(targetingMap).map(([key, value]) => ({
    key,
    value
  }));

  $prebidTargetingAtom.set(mergedTargeting);
}
